'use client';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Image from 'src/components/image';
import { FC, useMemo } from 'react';
import { Box, Container } from '@mui/material';

import { ComponentTypeProps } from '../../../../types/page-generator';
import { getContentValueFromProps } from '../../utils';

type CategoryType = {
  value: string;
  title: string;
  image: string;
};

const Attributes: FC<ComponentTypeProps> = ({ block }) => {
  const getFieldValue = getContentValueFromProps(block);

  const attributes: any = block?.categories || [];

  const attributesImages = useMemo(
    () => getFieldValue('attributesImages'),
    [block?.attributesImages]
  );

  const attributesImage = useMemo(() => {
    const categoriesValue = getFieldValue('categories');
    if (Array.isArray(categoriesValue)) {
      return categoriesValue.map((category: CategoryType) => ({
        ...category,
        image: attributesImages[category.value] ?? category?.image,
      }));
    }
    return [];
  }, [block?.categories, attributesImages]);

  // @ts-ignore
  const attributesList = (block?.attributes || []).map((attr: any) => ({
    id: attr.id,
    title: attr.name,
    // @ts-ignore
    image: block?.attributesImages?.[attr.id] || '', // добавим картинку по id, если есть
  }));

  return (
    <Stack direction="row" flexWrap="wrap">
      {attributesList.map((item: any, idx: any) => (
        <Box
          key={idx}
          sx={{
            position: 'relative',
            borderRadius: 1.25,
            height: '200px',
          }}
        >
          <Image
            src={item.image}
            sx={{
              borderRadius: 1.25,
              height: '100%',
              width: '100%',
              '& img': { objectFit: 'cover', height: '100%' },
            }}
          />
          <Typography
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.7)',
              position: 'absolute',
              bottom: '0px',
              width: '100%',
              height: '50px',
              pt: '10px',
              textAlign: 'center',
            }}
          >
            {item.title}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default Attributes;
